import { createAction, createReducer } from '@reduxjs/toolkit'

export interface MobileReferenceValue {
  code: string
  label: string | null
}

export interface MobileReferenceReducer {
  colors: MobileReferenceValue[]
  categories: MobileReferenceValue[]
  gearBoxes: MobileReferenceValue[]
  driveTypes: MobileReferenceValue[]
  vatRates: MobileReferenceValue[]
}

const initialState: MobileReferenceReducer = {
  colors: [],
  categories: [],
  gearBoxes: [],
  driveTypes: [],
  vatRates: []
}

export interface MobileReferencePayload {
  color: MobileReferenceValue[]
  category: MobileReferenceValue[]
  gear_box: MobileReferenceValue[]
  drive_type: MobileReferenceValue[]
  vat_rate: MobileReferenceValue[]
}

export const FETCH_MOBILE_REFERENCE_VALUES = createAction('mobile_reference_reducer/fetch')
export const FETCH_MOBILE_REFERENCE_VALUES_SUCCESS = createAction<MobileReferencePayload>(
  'mobile_reference_reducer/fetch_success'
)
export const FETCH_MOBILE_REFERENCE_VALUES_FAILURE = createAction('mobile_reference_reducer/fetch_failure')

export const mobileReferenceReducer = createReducer(initialState, (builder) => {
  builder.addCase(FETCH_MOBILE_REFERENCE_VALUES_SUCCESS, (state, action) => {
    return {
      ...state,
      colors: action.payload.color,
      categories: action.payload.category,
      gearBoxes: action.payload.gear_box,
      driveTypes: action.payload.drive_type,
      vatRates: action.payload.vat_rate
    }
  })
  builder.addCase(FETCH_MOBILE_REFERENCE_VALUES_FAILURE, () => {
    return initialState
  })
})
